import React, { useEffect, useRef, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import AI_PDF_CONST from "../util/PdfAiConst";
import useAuth from "../hooks/useAuth";
import { routeAllowed } from "./routeAccess";
import { authStore } from "./authStore";

const PrivateRoute = ({ element }) => {
  const location = useLocation();
  const { user, loading, error, refresh, revision } = useAuth();
  const isAuthenticated = Boolean(localStorage.getItem("token"));
  const allowed = routeAllowed(user, location.pathname, location.search);
  const checkedRoute = useRef(null);
  const [checking, setChecking] = useState(false);
  const routeKey = `${location.pathname}${location.search}`;

  useEffect(() => {
    if (!isAuthenticated || loading || error || !user || user.must_change_password || allowed) return;
    if (checkedRoute.current === routeKey) return;
    checkedRoute.current = routeKey;
    setChecking(true);
    Promise.resolve(authStore.invalidate(403)).finally(() => {
      setChecking(false);
    });
  }, [isAuthenticated, loading, error, user, allowed, routeKey]);

  if (!isAuthenticated) {
    return <Navigate to={AI_PDF_CONST.ROUTE.LOGIN} replace state={{ from: location }} />;
  }

  if (loading || (checking && !allowed)) return <p role="status">Verifying access…</p>;
  if (error) return <div role="alert">{error}<button onClick={() => refresh().catch(() => {})}>Retry</button></div>;
  if (user?.must_change_password && location.pathname !== "/account/security") return <Navigate to="/account/security" replace />;
  if (location.pathname === "/dashboard" && user && !routeAllowed(user, location.pathname, location.search)) return <Navigate to="/agents" replace />;
  if (!allowed) return <div role="alert">Access denied. You do not have permission to access this page. <button type="button" onClick={() => refresh().catch(() => {})}>Refresh permissions</button></div>;
  return <React.Fragment key={revision}>{element}</React.Fragment>;
};

export default PrivateRoute;
